export default "__VITE_ASSET__aQ4_0Fhk__"